import { EditOutlined } from '@ant-design/icons';
import { Button, DatePicker, message, Popover, Tooltip } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { fetchAPI } from '../../utils/api';

const EditDoDateInTable = (props: {
  date?: string;
  orderId: number;
  refreshList: () => void;
}) => {
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState(null);

  const saveDoDate = async () => {
    try {
      setLoading(true);
      await fetchAPI('order/do-date/bulk-update', {
        method: 'PATCH',
        payload: {
          saids: [props.orderId],
          do_date: date,
        },
      });
      setLoading(false);
      setVisible(false);
      props.refreshList();
    } catch (error) {
      if (error.message) {
        message.error(error.message);
      }
      setLoading(false);
    }
  };

  useEffect(() => {
    if (visible) {
      if (props.date) {
        try {
          setDate(moment(props.date));
        } catch (error) {
          setDate(null);
        }
      } else {
        setDate(null);
      }
    }
  }, [visible]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Popover
      visible={visible}
      onVisibleChange={vis => !loading && setVisible(vis)}
      title="Edit DO Date"
      trigger={'click'}
      placement="rightTop"
      content={
        <EditDoWrapper>
          <DatePicker
            format={'DD MMM YYYY'}
            value={date}
            onChange={momDate => setDate(momDate)}
            allowClear={false}
          />
          <Button
            type="primary"
            loading={loading}
            onClick={() => saveDoDate()}
            disabled={!date}
          >
            Save
          </Button>
        </EditDoWrapper>
      }
    >
      <Tooltip title="Edit DO Date">
        <EditOutlined
          style={{
            margin: '0 0px 0 10px',
          }}
        />
      </Tooltip>
    </Popover>
  );
};

const EditDoWrapper = styled.div`
  width: 200px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  > .ant-picker {
    width: 100%;
    margin-bottom: 15px;
  }
`;

export default EditDoDateInTable;
